import { useState, useEffect } from "react";
import { throttle } from "underscore";

const MOBILE_BREAKPOINT = 576;
const TABLET_BREAKPOINT = 768;

type Breakpoint = "mobile" | "tablet" | "desktop";

export default function useBreakpoint() {
  const [breakpoint, setBreakpoint] = useState(getCurrentBreakpoint());

  useEffect(() => {
    const handleResize = throttle(() => {
      setBreakpoint(getCurrentBreakpoint());
    }, 50);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    breakpoint,
    mobile: breakpoint === "mobile",
    tablet: breakpoint === "tablet",
    tabletAndBelow: breakpoint !== "desktop",
    desktop: breakpoint === "desktop",
  };
}

const getCurrentBreakpoint = (): Breakpoint => {
  const width = window.innerWidth;
  if (width <= MOBILE_BREAKPOINT) {
    return "mobile";
  }
  if (width > MOBILE_BREAKPOINT && width <= TABLET_BREAKPOINT) {
    return "tablet";
  }
  return "desktop";
};
